export type KioskOperationMode = "DONATE_AND_DEPOSIT" | "DONATE_ONLY";
export const DEFAULT_OPERATION_MODE: KioskOperationMode = "DONATE_AND_DEPOSIT";

export const resolveOperationMode = (value: unknown): KioskOperationMode | null => {
    if (value === undefined) return DEFAULT_OPERATION_MODE;
    return value === DEFAULT_OPERATION_MODE || value === "DONATE_ONLY" ? value : null;
};

export const operationModeLabel = (value: unknown): string => {
    const mode = resolveOperationMode(value);
    return mode === "DONATE_ONLY" ? "기부만" : mode === DEFAULT_OPERATION_MODE ? "기부 + 적립" : "운영 방식 확인 필요";
};
